function isRecord(obj) {
    return typeof obj === "object" && obj !== null;
}
function isGeoClient(geo) {
    if (isRecord(geo) &&
        "getLocationApproximation" in geo &&
        typeof geo.getLocationApproximation === "function") {
        return true;
    }
    return false;
}
export { isGeoClient };
//# sourceMappingURL=helpers.js.map